/* ==========================================================================
   Driftback theme fixes
   Loaded from layout/theme.liquid. Deliberately a classic script with no
   imports, so it runs everywhere regardless of module support.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     1. Checkout button on iOS

     The cart's checkout button is a submit button posting the cart form to
     /cart from inside a native <dialog> (the cart drawer). Safari on iOS can
     mishandle that navigation and offer the response as a file download
     instead of following the redirect, which is where the "Do you want to
     download 'cart'" prompt comes from.

     Navigating directly to /checkout does the same job and avoids the form
     post entirely. The cart contents live server-side against the cart cookie,
     so nothing is lost by skipping the post.
     ---------------------------------------------------------------------- */
  function checkoutUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (root + 'checkout').replace('//', '/');
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('#checkout, .cart__checkout-button');
      if (!button || button.disabled) return;

      event.preventDefault();
      button.setAttribute('aria-busy', 'true');
      window.location.href = checkoutUrl();
    },
    true
  );

  /* ------------------------------------------------------------------------
     2. Stale cart count after a back navigation

     Going to checkout and pressing back restores the page from the browser's
     back/forward cache, frozen exactly as it was before the item was added, so
     the cart bubble keeps showing the old count.

     Earlier this only ran on pageshow with event.persisted set. Desktop
     browsers set that flag reliably; iOS Safari frequently restores from
     bfcache without it, which is why the fix worked on desktop and not on an
     iPhone. So the check now runs on every pageshow and whenever the tab
     becomes visible again, and instead of reloading it syncs the bubble in
     place. That is instant, and it cannot loop the way a reload can if the
     comparison ever disagrees.
     ---------------------------------------------------------------------- */
  var syncing = false;

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function paintBubble(count) {
    var bubble = document.querySelector('[ref="cartBubble"], .cart-bubble');
    var countEl = document.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count');
    if (!bubble || !countEl) return false;

    var shown = parseInt((countEl.textContent || '').replace(/[^0-9]/g, ''), 10);
    if (isNaN(shown)) shown = 0;
    if (shown === count) return false;

    countEl.textContent = count > 99 ? '99+' : String(count);
    bubble.classList.toggle('visually-hidden', count === 0);
    countEl.classList.toggle('hidden', count === 0);
    return true;
  }

  function refreshDrawer() {
    // The drawer markup is also frozen by bfcache, so a corrected bubble with
    // stale contents behind it would just move the problem. Re-render it from
    // the Section Rendering API, but never while it is open, and never at the
    // cost of the page if it fails.
    var wrapper = document.getElementById('shopify-section-cart-drawer-section');
    if (!wrapper || wrapper.querySelector('dialog[open]')) return;

    fetch(shopRoot() + '?sections=cart-drawer-section', { cache: 'no-store' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (sections) {
        var html = sections && sections['cart-drawer-section'];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById('shopify-section-cart-drawer-section') || parsed.body.firstElementChild;
        if (fresh) wrapper.innerHTML = fresh.innerHTML;
      })
      .catch(function () {
        /* Leave the existing drawer in place. */
      });
  }

  function syncCart() {
    if (syncing || document.hidden) return;
    syncing = true;

    fetch(shopRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart && paintBubble(cart.item_count)) refreshDrawer();
      })
      .catch(function () {
        /* Offline or blocked: leave the restored page as it is. */
      })
      .finally(function () {
        syncing = false;
      });
  }

  /* ------------------------------------------------------------------------
     3. Buttons left stuck in their busy state

     Same cause as the stale bubble. A button that was disabled and relabelled
     ("Adding...", "One moment...") at the instant we navigated to checkout is
     restored from bfcache exactly like that, so pressing back leaves a dead
     button with a misleading label.

     Any button that goes busy records its original label in
     data-db-restore-label and clears it when it finishes normally. Anything
     still carrying that attribute on a restored page never finished, so it is
     put back. The checkout button only sets aria-busy, so clear that too.
     ---------------------------------------------------------------------- */
  function resetBusyButtons() {
    document.querySelectorAll('[data-db-restore-label]').forEach(function (button) {
      button.textContent = button.dataset.dbRestoreLabel;
      button.disabled = false;
      delete button.dataset.dbRestoreLabel;
    });

    document.querySelectorAll('[aria-busy="true"]').forEach(function (el) {
      el.removeAttribute('aria-busy');
    });
  }

  function onRestore() {
    resetBusyButtons();
    syncCart();
  }

  window.addEventListener('pageshow', onRestore);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) onRestore();
  });
})();
